import { differenceWith, pipe, map, propEq } from 'ramda';

export var optionComparator = function optionComparator(obj1, obj2) {
  return obj1.label === obj2.label;
};

export var makeOption = function makeOption(_ref) {
  var label = _ref.label;
  return { value: label, label: label };
};

export var makeOptions = pipe(differenceWith(optionComparator), map(makeOption));

export var valueEquals = propEq('value');